module.exports = __webpack_public_path__ + "img/marker.1a8276f4.png";